import React from 'react';
// This is the candidate onboarding page
interface CandidateOnboardingProps {
    formRef: React.RefObject<HTMLFormElement>;
    handleCandidateOnboarding: (event: React.FormEvent) => void;
    userId: string;
}

const CandidateOnboarding: React.FC<CandidateOnboardingProps> = ({ formRef, handleCandidateOnboarding, userId }) => {
    return (
        <div className="container mx-auto p-4 flex justify-center items-center h-screen">
            <div className="w-full max-w-lg bg-white shadow-md rounded-lg p-6">
                <h1 className="text-2xl mb-4 text-center">Candidate Onboarding</h1>
                <form ref={formRef} onSubmit={handleCandidateOnboarding} className="space-y-4">
                    <div>
                        <input type="hidden" name="userId" value={userId} />
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
                            Name
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="name"
                            name="name"
                            type="text"
                            placeholder="Enter your name"
                        />
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                            Email
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="email"
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                        />
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="phone">
                            Phone Number
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="phone"
                            name="phone"
                            type="tel"
                            placeholder="Enter your phone number"
                        />
                    </div>
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="resume">
                            Upload Resume
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="resume"
                            name="resume"
                            type="file"
                        />
                    </div>
                    <div className="flex items-center">
                        <input
                            className="mr-2 leading-tight"
                            type="checkbox"
                            id="terms"
                            name="terms"
                        />
                        <label className="text-sm" htmlFor="terms">
                            I agree to the <a href="/terms" className="text-blue-500">terms and conditions</a> and <a href="/privacy" className="text-blue-500">privacy policy</a>
                        </label>
                    </div>
                    <div className="flex items-center">
                        <input
                            className="mr-2 leading-tight"
                            type="checkbox"
                            id="findable"
                            name="findable"
                        />
                        <label className="text-sm" htmlFor="findable">
                            I would like recruiters to be able to find me.
                        </label>
                    </div>
                    <div className="flex items-center justify-between">
                        <button
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                            type="submit"
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
export default CandidateOnboarding;